export default __webpack_public_path__ + "static/media/survey-response.696cbc65.gif";